















import Vue from 'vue'

// 画面中のjsAudioPlayerボタンを初期化する
// (jsAudioPlayer.jsをロードして初期化処理を動かす)
// １コンポーネントごとにではなく、１画面に１回だけ呼び出す
// 呼び出すタイミングは class="js-audioPlayer"のDOMエレメントが全て生成された後でないといけない
// ボタンが増えるなどして再度初期化する場合は一度destructしてから再度constructする
export const constructJsAudioPlayer = (): any => {
  const afterScriptLoad = (ev?: Event): any => {
    ev?.target?.removeEventListener('load', afterScriptLoad)

    Vue.nextTick(() => {
      // スクリプト中のボタン初期化処理を動かすためにイベントを手動で発火する
      if (document.getElementsByClassName('js-audioPlayer').length > 0) {
        // 親ノードからdata-keyの設定を反映する
        for(const div of document.getElementsByClassName('js-audioPlayer')) {
          const dataKey = div.parentElement?.getAttribute('data-key')
          if(dataKey) {
            div.setAttribute('data-key', dataKey)
          }
        }
        document.dispatchEvent(new Event('DOMContentLoaded', { bubbles: true, cancelable: true }))
      }
    })
  }

  const afterWindowLoad = (ev?: Event): any => {
    ev?.target?.removeEventListener('load', afterWindowLoad)

    if (!document.getElementById('jsAudioPlayerCss')) {
      const css = document.createElement('link')
      css.setAttribute('id', 'jsAudioPlayerCss')
      css.setAttribute('rel', 'stylesheet')
      css.setAttribute('href', '/css/jukusuitePlayer.css')
      document.head.appendChild(css)
    }

    if (!document.getElementById('jsAudioPlayerScript')) {
      const script = document.createElement('script')
      script.setAttribute('id', 'jsAudioPlayerScript')
      script.setAttribute('src', '/js/jukusuitePlayer.js?ver=20260201')
      script.onload = afterScriptLoad
      document.head.appendChild(script)
    } else {
      afterScriptLoad()
    }
  }

  if (document.readyState === 'complete') {
    afterWindowLoad()
  } else {
    window.addEventListener('load', afterWindowLoad)
  }
}

// ロードしたjsAudioPlayerスクリプトを破棄する
export const destructJsAudioPlayer = (): any => {
  for(const div of document.getElementsByClassName('js-audioPlayer')) {
    // イベントリスナー等を除去した状態に戻す
    const cloned = div.cloneNode(false)
    div.parentNode?.replaceChild(cloned, div)
  }
  const scripttag = document.getElementById('jsAudioPlayerScript')
  if (scripttag) {
    document.head.removeChild(scripttag)
  }
  const csstag = document.getElementById('jsAudioPlayerCss')
  if (csstag) {
    document.head.removeChild(csstag)
  }
}

export default Vue.extend({
  props: {
    dataKey: {
      type: String,
      required: true
    }
  },
})
